export var fieldsetProps = function fieldsetProps(props) {
  return {
    values: props.values,
    touched: props.touched,
    errors: props.errors,
    handleChange: props.handleChange,
    handleBlur: props.handleBlur,
    isFieldRequired: props.isFieldRequired,
    getFieldLabel: props.getFieldLabel,
    getFieldPlaceholder: props.getFieldPlaceholder,
    getSelectFieldOptions: props.getSelectFieldOptions,
    hasField: function hasField(name) {
      return name in props.values;
    }
  };
};
export var formErrorMessage = function formErrorMessage(errors, touched) {
  return function (name) {
    return touched[name] && errors[name] ? errors[name] : "";
  };
};
export var newFieldProps = function newFieldProps(_ref) {
  var values = _ref.values,
    errors = _ref.errors,
    touched = _ref.touched,
    handleChange = _ref.handleChange,
    handleBlur = _ref.handleBlur;
  return function (name) {
    return {
      name: name,
      value: values[name],
      error: formErrorMessage(errors, touched)(name),
      onChange: handleChange,
      onBlur: handleBlur
    };
  };
};